import { langPrefix } from "../../languages";

export const blogPath = (lang) => langPrefix(lang) + "/blog/";

export const quotePath = (lang) => langPrefix(lang) + "/devis-reservation-vtc/";

// Each article carries every language; keep the root fields (_id, category, trip...) next to the translation.
export const pickTranslation = (article, lang) => {
  const translation = article.translations.find((t) => t.lang === lang);
  if (!translation) return null;
  const { translations, ...root } = article;
  return { ...root, ...translation, translations };
};

// French puts a space before : ; ? ! and inside « » — make it non-breaking so a sign never starts a line.
export const frenchSpacing = (text, lang) =>
  lang === "fr" && text ? text.replace(/ ([:;?!»])/g, "\u00a0$1").replace(/« /g, "«\u00a0") : text;

export const formatDate = (iso, lang) =>
  new Intl.DateTimeFormat(lang, { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" })
    .format(new Date(iso));

// An article revised after publication shows when it was last updated; otherwise its publication date.
export const isRevised = (article) =>
  !!article.updatedAt && new Date(article.updatedAt).getTime() !== new Date(article.createdAt).getTime();

export const displayDate = (article) => (isRevised(article) ? article.updatedAt : article.createdAt);

export const formatDuration = (minutes, lang) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const units = { ru: ["ч", "мин"], de: ["Std.", "Min."] }[lang] || ["h", "min"];
  if (!h) return `${m} ${units[1]}`;
  if (!m) return `${h} ${units[0]}`;
  // "2 h 15" reads well in French, English, Italian and Russian; German needs both units: "2 Std. 15 Min."
  return lang === "de" ? `${h} ${units[0]} ${m} ${units[1]}` : `${h} ${units[0]} ${String(m).padStart(2, "0")}`;
};

// Rebuilds any of our Cloudinary URL formats with a new transformation, e.g. "c_fill,g_auto,ar_3:2,w_800".
export const cloudinary = (url, transformation) => {
  const match = (url || "").match(/^(https:\/\/res\.cloudinary\.com\/[^/]+)\/(?:image\/upload\/)?(?:.*?\/)?(v\d+\/.+)$/);
  if (!match) return url;
  return `${match[1]}/image/upload/${transformation},q_auto,f_auto/${match[2]}`;
};

export const cloudinarySrcSet = (url, transformation, widths) =>
  widths.map((w) => `${cloudinary(url, `${transformation},w_${w}`)} ${w}w`).join(", ");
